'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './appconfs.routes';

import list from './list';
import show from './show';
import add from './add';
import edit from './edit';
import code from './code'
import importConfs from './import';

export default angular.module('onyxReadingRoomApp.appconfs', [uiRouter, list, code, show, add, edit, importConfs])
  .config(routing)
  .run(function ($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
      if (next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfs/index.js